// constant
export const LOAD_MORTICIAIN = "loadMorticiain";

import router from "@/router";
import {
  requestPointList,
  requestPointPaybackList,
  requestPointPayback
} from "../apis/payback_api";

const state = {
  period: `${new Date().getFullYear()}년 ${new Date().getMonth() +
    1}월 ~ ${new Date().getFullYear()}년 ${new Date().getMonth() + 1}월`,
  years: [`${new Date().getFullYear() - 1}`, `${new Date().getFullYear()}`],
  months: [],
  selectStartYear: new Date().getFullYear(),
  selectStartMonth: new Date().getMonth() + 1,
  selectEndYear: new Date().getFullYear(),
  selectEndMonth: new Date().getMonth() + 1,
  step: "phone-certify",
  bank: "",
  bankCertifyStep: "select-bank",
  name: "",
  phone: "",

  pointList: [],
  pointListPage: null,
  pointListPageTotal: null,
  pointListTotalElements: null,
  wreathCount: 0,
  movieCount: 0,
  wreathCancelCount: 0,
  movieCancelCount: 0,
  totalPoint: 0,

  plusPointTotal: 0,
  minusPointTotal: 0,
  minusPointList: []
};

const getters = {
  getYears: state => state.years,
  getMonths: state => state.months,
  getStartYear: state => state.selectStartYear,
  getStartMonth: state => state.selectStartMonth,
  getEndYear: state => state.selectEndYear,
  getEndMonth: state => state.selectEndMonth,
  getPeriod: state => state.period,

  getPointList: state => state.pointList,
  getPointListPage: state => state.pointListPage,
  getPointListPageTotal: state => state.pointListPageTotal,
  getPointListTotalElements: state => state.pointListTotalElements,
  getWreathCount: state => state.wreathCount,
  getMovieCount: state => state.movieCount,
  getWreathCancelCount: state => state.wreathCancelCount,
  getMovieCancelCount: state => state.movieCancelCount,
  getTotalPoint: state => state.totalPoint,

  getPlusPointTotal: state => state.plusPointTotal,
  getMinusPointTotal: state => state.minusPointTotal,
  getMinusPointList: state => state.minusPointList
};

const mutations = {
  setYears(state, data) {
    state.years = data;
  },
  setMonths(state, data) {
    state.months = data;
  },
  setStartYear(state, data) {
    state.selectStartYear = data;
  },
  setStartMonth(state, data) {
    state.selectStartMonth = data;
  },
  setEndYear(state, data) {
    state.selectEndYear = data;
  },
  setEndtMonth(state, data) {
    state.selectEndMonth = data;
  },
  setPeriod(state, data) {
    state.period = data;
  },
  setNamePhone(state, data) {
    const { name, phone } = data;
    state.name = name;
    state.phone = phone;
  },
  setVerifyStatus(state, data) {
    state.step = data;
  },
  setBankInfo(state, data) {
    state.bank = data;
    state.step = "bank-certify";
    state.bankCertifyStep = "input-account";
  },
  setCertifyStep(state, data) {
    state.bankCertifyStep = data;
  },
  resetBankInfo(state, data) {
    state.bank = "";
    state.step = "";
  },

  SET_POINT_LIST(state, data) {
    state.pointList = data.resultPointList;
    state.pointListPage = data.page;
    state.pointListPageTotal = data.pageTotal;
    state.pointListTotalElemtnts = data.totalElemtnts;

    state.wreathCount =
      data.resultWreathCount === undefined ? 0 : data.resultWreathCount;
    state.movieCount =
      data.resultMovieCount === undefined ? 0 : data.resultMovieCount;
    state.wreathCancelCount =
      data.resultWreathCancelCount === undefined ? 0 : data.resultWreathCancelCount;
    state.movieCancelCount =
      data.resultMovieCancelCount === undefined ? 0 : data.resultMovieCancelCount;
    state.totalPoint = data.totalPoint;
  },

  SET_POINT_PAYBACK_LIST(state, data) {
    state.plusPointTotal = data.plusPointTotal;
    state.minusPointTotal = data.minusPointTotal;
    state.minusPointList = data.minusPointList;
  },
  POINT_INIT(state) {
    state.totalPoint = 0;
    state.plusPointTotal = 0;
    state.minusPointTotal = 0;
    state.minusPointList = [];
  }
};

const actions = {
  async certifyPhone({ commit }, payload) {
    try {
      const { name, phone } = payload;
      commit("setNamePhone", { name, phone });

      const res = await this.$axios.post(
        "/mortician/account",
        {
          name,
          phone
        },
        {
          withCredentials: true
        }
      );

      if (res.status === 201) {
        alert(res.data);
        commit("setVerifyStatus", "phone-certify");
        return;
      }

      commit("setVerifyStatus", "send");
    } catch (err) {
      console.error(err);
    }
  },

  async certifyVerificationCode({ commit }, payload) {
    try {
      const { code } = payload;
      const res = await this.$axios.post(
        "/mortician/verification",
        {
          code
        },
        {
          withCredentials: true
        }
      );
      if (res.status === 203) {
        return alert(res.data);
      }
      alert("인증되었습니다");
      commit("setVerifyStatus", "bank-certify");
    } catch (err) {
      console.error(err);
    }
  },
  async accountCertify({ commit }, payload) {
    try {
      const { name, code, account } = payload;

      const res = await this.$axios.put(
        "/mortician/account",
        {
          name,
          bankCode: code,
          bankAccount: account
        },
        {
          withCredentials: true
        }
      );

      if (res.status === 203) {
        return alert(res.data);
      }
      const { bank_holder } = res.data.response;

      const confirmAccount = confirm(`예금주 ${bank_holder} 맞습니까?`);

      if (confirmAccount) {
        const res = await this.$axios.post(
          "/mortician/account/confirm",
          {
            name,
            bank_holder,
            bankAccount: account
          },
          {
            withCredentials: true
          }
        );
        if (res.status === 203) {
          return alert(res.data);
        }
        alert(res.data);
        commit("setVerifyStatus", "complete");
      } else {
        alert("취소되었습니다");
      }
    } catch (err) {
      console.error(err);
    }
  },
  async retryPhoneVerify({ commit }, payload) {
    try {
      const { morticianId } = payload;
      const res = await this.$axios.put(
        "/mortician/verification-reset",
        {
          morticianId
        },
        {
          withCredentials: true
        }
      );

      if (res.data) commit("setVerifyStatus", "retry");
    } catch (err) {
      console.error(err);
    }
  },

  async REQUEST_POINT_LIST({ commit }, parameter) {
    try {
      commit("START_LOADING");
      const res = await requestPointList(parameter);

      const { data } = res;

      if (data?.result !== "success") {
        return alert(data.message);
      }

      commit("SET_POINT_LIST", data);
    } catch (err) {
      console.error(err);
    } finally {
      commit("END_LOADING");
    }
  },

  async REQUEST_POINT_PAYBACK_LIST({ commit }, parameter) {
    try {
      commit("START_LOADING");
      const res = await requestPointPaybackList(parameter);

      const { data } = res;

      if (data?.result !== "success") {
        return alert(data.message);
      }

      commit("SET_POINT_PAYBACK_LIST", data);
    } catch (err) {
      console.error(err);
    } finally {
      commit("END_LOADING");
    }
  },
  async REQUEST_POINT_PAYBACK({ commit }, parameter) {
    try {
      commit("START_LOADING");
      const res = await requestPointPayback(parameter);

      const { data } = res;

      if (data?.result !== "success") {
        alert(data.message);
        return false;
      }

      return true;
    } catch (err) {
      console.error(err);
      return false;
    } finally {
      commit("END_LOADING");
    }
  }
};

export default { mutations, state, actions, getters };

// store
